export default () => (
  <svg
    width='16'
    height='16'
    viewBox='0 0 16 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M8 0C4.68629 0 2 2.68629 2 6C2 8.23658 3.284 10.1842 5.19602 11.1807C5.07811 11.5396 4.99511 11.9115 4.95 12.2923C4.82812 13.3476 4.9903 14.3599 5.29341 15.1066C5.42107 15.4271 5.71077 15.627 6.05 15.627H9.95C10.2892 15.627 10.5789 15.4271 10.7066 15.1066C11.0097 14.3599 11.1719 13.3476 11.05 12.2923C11.0049 11.9115 10.9219 11.5396 10.804 11.1807C12.716 10.1842 14 8.23658 14 6C14 2.68629 11.3137 0 8 0ZM3.5 6C3.5 3.51472 5.51472 1.5 8 1.5C10.4853 1.5 12.5 3.51472 12.5 6C12.5 7.75814 11.4414 9.30831 9.88362 10.0215C9.5787 9.77751 9.24477 9.56687 8.88888 9.3955C8.22291 9.06809 7.44861 8.89773 6.67148 8.89803C5.82362 8.89836 4.99043 9.1245 4.22055 9.56384C3.28794 8.63687 2.75 7.35948 2.75 6H3.5ZM6 12.462C6.0669 11.9774 6.18994 11.513 6.36452 11.0863C6.65906 10.3565 7.32889 10.0131 8.06118 10.3654C8.49879 10.5761 8.91711 10.8776 9.27758 11.2473C9.45063 11.4254 9.59161 11.6165 9.7 11.8123C9.79217 11.9811 9.87318 12.1733 9.94001 12.3839C10.025 12.6506 10.0866 12.9381 10.1221 13.2305C10.1715 13.6307 10.1471 13.9894 10.059 14.2306H5.94102C5.85289 13.9894 5.82852 13.6307 5.8779 13.2305C5.9134 12.9381 5.97501 12.6506 6.06 12.3839C6.08425 12.3077 6.10744 12.2324 6.13 12.1581C6.08687 12.2572 6.04381 12.358 6 12.462Z'
      fill='#5A607F'
    />
    <path
      d='M13.25 2.75L13.75 1.5L14.25 2.75L15.5 3.25L14.25 3.75L13.75 5L13.25 3.75L12 3.25L13.25 2.75Z'
      fill='#5A607F'
    />
  </svg>
);
